module.exports = __webpack_public_path__ + "img/smart6.f9732cf8.png";